// extracted by mini-css-extract-plugin
export default {"root":"_cKM8AhT1fewlFvMkL90"};